import React from 'react';
import { Form, Input, Button } from 'antd';

function Support() {
  const onFinish = (values) => {
    console.log('Form values:', values);
  };

  return (
    <div style={{ padding: '20px' }}>
      <h1>Support</h1>
      <p>Please fill out the form below to contact support.</p>
      
      <Form onFinish={onFinish}>
        <Form.Item
          name="message"
          rules={[{ required: true, message: 'Please enter your message' }]}
        >
          <Input.TextArea rows={4} placeholder="Enter your message here" />
        </Form.Item>

        <Form.Item>
          <Button type="primary" htmlType="submit">
            Submit
          </Button>
        </Form.Item>
      </Form>
    </div>
  );
};

export default Support;

